import RestApiModel from "@/api/Model/RestApiModel";

class DocumentCategory extends RestApiModel {
  static getResourceEndpoint() {
    return '/SalesToolHeaders';
  }
}

export default DocumentCategory;
